import { useFeatureFlags } from '@core/context/FeatureFlagsContext';

import styles from './RoundFieldTest.module.css';

type ReturnType = {
  smRounded: string;
  mdRounded: string;
  lgRounded: string;
  xlRounded: string;
  twoXlRounded: string;
  threeXlRounded: string;
  fullRounded: string;
  isTest: boolean;
};

const useRoundFieldsTest = (): ReturnType => {
  const flags = useFeatureFlags();

  const isTest = flags.roundFieldsTest === 'test';

  return {
    smRounded: isTest ? styles.sm : '',
    mdRounded: isTest ? styles.md : '',
    lgRounded: isTest ? styles.lg : '',
    xlRounded: isTest ? styles.xl : '',
    twoXlRounded: isTest ? styles['two-xl'] : '',
    threeXlRounded: isTest ? styles['three-xl'] : '',
    fullRounded: isTest ? styles.full : '',
    isTest,
  };
};

export default useRoundFieldsTest;
